import React, { useEffect, useState, useMemo, useCallback } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faTimes,
  faHome,
  faInfoCircle,
  faSun,
  faMoon,
  faTshirt,
  faGraduationCap,
  faStar,
  faEnvelope,
  faPalette,
  faUsers,
  faPaintBrush,
  faTruck,
  faLeaf,
  faLightbulb,
  faRocket,
  faHandshake,
  faGlobe,
  faGem,
  faSmile,
  faDollarSign,
  faFire,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { motion, AnimatePresence } from 'framer-motion';
import { Parallax } from 'react-parallax';
import { Tilt } from 'react-tilt';
import AOS from 'aos';
import 'aos/dist/aos.css';
import banner1 from './images/banner (1).jpg';
import banner2 from './images/banner (2).jpg';
import banner3 from './images/banner (3).jpg';
import banner4 from './images/banner (4).jpg';
import banner5 from './images/banner (5).jpg';
import banner6 from './images/banner (6).jpg';
import graphictees1 from './images/graphictees (1).jfif';
import graphictees2 from './images/graphictees (2).jfif';
import graphictees3 from './images/graphictees (3).jfif';
import totebag1 from './images/totebag (1).jfif';
import totebag2 from './images/totebag (2).jfif';
import totebag3 from './images/totebag (3).jfif';
import hoodies1 from './images/hoodies (1).jfif';
import hoodies2 from './images/hoodies (2).jfif';
import hoodies3 from './images/hoodies (3).jfif';
import oversizedtees1 from './images/oversizedtees (1).jfif';
import oversizedtees2 from './images/oversizedtees (2).jfif';
import highlight1 from './images/Highlight Showcase (1).jfif';
import highlight2 from './images/Highlight Showcase (2).jfif';
import highlight3 from './images/Highlight Showcase (3).jfif';
import highlight4 from './images/Highlight Showcase (4).jfif';
import highlight5 from './images/Highlight Showcase (5).jpg';


// Navbar Component
const Navbar = React.memo(({ theme, toggleTheme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = useCallback(() => setIsOpen((prev) => !prev), []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className={`sticky top-0 backdrop-blur-lg z-50 shadow-sm ${theme === 'dark' ? 'bg-black/90' : 'bg-white/90'} font-poppins`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          className={`text-xl sm:text-2xl lg:text-3xl font-bold ${theme === 'dark' ? 'text-white' : 'text-black'}`}
        >
          Flex Clothing
        </motion.div>
        <div className="hidden md:flex space-x-4 lg:space-x-8 items-center">
          {['home', 'about', 'categories', 'contact'].map((item, index) => (
            <motion.a
              key={item}
              href={`#${item}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + index * 0.1 }}
              whileHover={{ scale: 1.1, color: '#f59e0b' }}
              className={`${theme === 'dark' ? 'text-white hover:text-accent' : 'text-black hover:text-accent'} flex items-center gap-2 text-sm lg:text-base font-inter relative group`}
            >
              <FontAwesomeIcon
                icon={item === 'home' ? faHome : item === 'about' ? faInfoCircle : item === 'categories' ? faTshirt : faEnvelope}
              />
              {item.charAt(0).toUpperCase() + item.slice(1)}
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-accent scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
            </motion.a>
          ))}
          <motion.button
            onClick={toggleTheme}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
            whileHover={{ scale: 1.2, rotate: 360 }}
            whileTap={{ scale: 0.9 }}
            className={`${theme === 'dark' ? 'text-white hover:text-accent' : 'text-black hover:text-accent'} focus:outline-none transition font-inter`}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} size="lg" />
          </motion.button>
        </div>
        <div className="md:hidden flex items-center gap-4">
          <motion.button
            onClick={toggleTheme}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
            className={`${theme === 'dark' ? 'text-white hover:text-accent' : 'text-black hover:text-accent'} focus:outline-none transition font-inter`}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} size="lg" />
          </motion.button>
          <motion.button
            onClick={toggleMenu}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
            className={`${theme === 'dark' ? 'text-white hover:text-accent' : 'text-black hover:text-accent'} focus:outline-none transition font-inter`}
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
          >
            <FontAwesomeIcon icon={isOpen ? faTimes : faBars} size="lg" />
          </motion.button>
        </div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className={`md:hidden ${theme === 'dark' ? 'bg-black' : 'bg-white'} py-4 font-inter`}
          >
            {['home', 'about', 'categories', 'contact'].map((item, index) => (
              <motion.a
                key={item}
                href={`#${item}`}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05, x: 10 }}
                className={`${theme === 'dark' ? 'text-white hover:text-accent' : 'text-black hover:text-accent'} block px-4 py-2 transition flex items-center gap-2 text-sm`}
                onClick={toggleMenu}
              >
                <FontAwesomeIcon
                  icon={item === 'home' ? faHome : item === 'about' ? faInfoCircle : item === 'categories' ? faTshirt : faEnvelope}
                />
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </motion.a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
});

//Banner Hero Component
const Hero = React.memo(({ theme }) => {
  const banners = useMemo(() => [banner1, banner2, banner3, banner4, banner5, banner6], []);

  const settings = useMemo(() => ({
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    fade: true,
    cssEase: 'ease-in-out',
    arrows: false,
    responsive: [{ breakpoint: 640, settings: { dots: false } }],
  }), []);

  return (
    <Parallax
      bgImage={banners[0]}
      strength={300}
      className="relative w-full h-[60vh] sm:h-[80vh] lg:h-screen overflow-hidden"
    >
      {/* Background Slider */}
      <div className="absolute inset-0 w-full h-full z-0">
        <Slider {...settings}>
          {banners.map((banner, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 1.2 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, ease: 'easeOut' }}
              className="relative w-full h-[60vh] sm:h-[80vh] lg:h-screen"
            >
              <img
                src={banner}
                alt={`Banner ${index + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/80 z-[5]" />
            </motion.div>
          ))}
        </Slider>
      </div>

      {/* Hero Content */}
      <div className="absolute top-0 left-0 w-full min-h-[60vh] sm:min-h-[80vh] lg:min-h-screen z-20 flex items-center justify-center text-center px-4 sm:px-6 py-4">
        <motion.div
          className="max-w-3xl mx-auto w-full"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.h1
            className="text-2xl xs:text-3xl sm:text-4xl lg:text-5xl font-poppins font-bold uppercase text-white"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            Flex Your Style
          </motion.h1>
          <motion.p
            className="mt-3 text-sm xs:text-base sm:text-lg lg:text-xl font-inter text-white max-w-[90%] sm:max-w-2xl mx-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            Discover premium college merchandise and custom apparel designed for the youth. Stand out with our trendy, high-quality collections.
          </motion.p>
          <motion.div
            className="mt-6 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center flex-wrap px-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            <motion.a
              href="#categories"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full sm:w-auto text-center bg-white text-black font-inter px-4 sm:px-6 py-2 sm:py-3 rounded hover:bg-accent transition flex items-center justify-center gap-2 text-sm sm:text-base"
            >
              <FontAwesomeIcon icon={faTshirt} /> Explore Categories
            </motion.a>
            <motion.a
              href="#contact"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full sm:w-auto text-center bg-white text-black font-inter px-4 sm:px-6 py-2 sm:py-3 rounded hover:bg-accent transition flex items-center justify-center gap-2 text-sm sm:text-base"
            >
              <FontAwesomeIcon icon={faEnvelope} /> Contact Us
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </Parallax>
  );
});

// BestDesigns Component
const BestDesigns = React.memo(({ theme }) => {
  const categories = useMemo(
    () => [
      {
        name: 'Oversized Tees',
        description: 'Bold, comfy, and perfect for casual vibes.',
        icon: faTshirt,
        color: 'text-indigo-600',
      },
      {
        name: 'Hoodies',
        description: 'Cozy up with our stylish and warm hoodies.',
        icon: faTshirt,
        color: 'text-gray-700',
      },
      {
        name: 'College Drops',
        description: 'Exclusive merch for your college pride.',
        icon: faGraduationCap,
        color: 'text-purple-600',
      },
      {
        name: 'Graphic Tees',
        description: 'Eye-catching prints that make a statement.',
        icon: faPalette,
        color: 'text-pink-500',
      },
    ],
    []
  );

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="py-12 sm:py-16" data-aos="fade-up">
      <motion.h2
        className={`text-2xl sm:text-3xl lg:text-4xl font-poppins font-bold text-center ${
          theme === 'dark' ? 'text-white' : 'text-black'
        } mb-8 sm:mb-12`}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Our Best Designs
      </motion.h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4 sm:px-8 lg:px-16">
        {categories.map((category, index) => (
          <Tilt
            key={index}
            options={{ max: 25, scale: 1.05, speed: 400, perspective: 1000 }}
          >
            <motion.div
              data-aos="zoom-in"
              data-aos-delay={index * 100}
              className={`${
                theme === 'dark'
                  ? 'bg-white/90 text-black'
                  : 'bg-gray-100 text-black'
              } p-6 rounded-xl shadow-lg flex flex-col items-center justify-center h-full hover:scale-105 transition-transform duration-300 font-inter`}
              whileHover={{
                rotateX: 5,
                rotateY: 5,
                boxShadow: '0 15px 30px rgba(0,0,0,0.2)',
              }}
            >
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                whileHover={{ scale: 1.2, rotate: 15 }}
                transition={{ duration: 0.3 }}
                viewport={{ once: true }}
                className="text-3xl mb-3"
              >
                <FontAwesomeIcon
                  icon={category.icon}
                  className={`${category.color} hover:text-amber-500 transition-colors duration-200`}
                />
              </motion.div>
              <h3 className="text-lg sm:text-xl font-bold text-center mt-2">
                {category.name}
              </h3>
              <p className="text-sm sm:text-base text-center mt-2">
                {category.description}
              </p>
            </motion.div>
          </Tilt>
        ))}
      </div>
    </div>
  );
});

// WhyChooseFlex
const WhyChooseFlex = React.memo(() => {
  const reasons = useMemo(
    () => [
      {
        title: 'Trending College Wear',
        description: 'Stay ahead with the latest campus fashion trends.',
        icon: faStar,
        color: 'text-yellow-500',
      },
      {
        title: 'Youth-Focused Designs',
        description: 'Designed for the vibrant college lifestyle.',
        icon: faUsers,
        color: 'text-orange-500',
      },
      {
        title: 'Customization Available',
        description: 'Create apparel that reflects your unique style.',
        icon: faPaintBrush,
        color: 'text-cyan-500',
      },
      {
        title: 'Quick Order Fulfillment',
        description: 'Fast delivery to keep up with your schedule.',
        icon: faTruck,
        color: 'text-blue-500',
      },
      {
        title: 'Eco-Friendly Options',
        description: 'Sustainable fabrics for a greener planet.',
        icon: faLeaf,
        color: 'text-green-500',
      },
    ],
    []
  );

  return (
    <div className="py-12 sm:py-16 bg-white" data-aos="fade-up">
      <motion.h2
        className="text-2xl sm:text-3xl lg:text-4xl font-poppins font-bold text-center text-black mb-8 sm:mb-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Why Choose Flex
      </motion.h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 px-4 sm:px-8 lg:px-16">
        {reasons.map((reason, index) => (
          <Tilt
            key={index}
            options={{ max: 20, scale: 1.05, speed: 400, perspective: 1000 }}
          >
            <motion.div
              className="bg-white text-black p-6 rounded-xl shadow-md flex flex-col items-center justify-center h-full hover:scale-105 transition-transform duration-300 font-inter"
              data-aos="fade-up"
              data-aos-delay={index * 100}
              whileHover={{
                rotateX: 5,
                rotateY: 5,
                boxShadow: '0 15px 30px rgba(0,0,0,0.2)',
              }}
            >
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                whileHover={{ scale: 1.2, rotate: 15 }}
                transition={{ duration: 0.3 }}
                viewport={{ once: true }}
                className="text-3xl mb-3"
              >
                <FontAwesomeIcon
                  icon={reason.icon}
                  className={`${reason.color} hover:text-amber-500 transition-colors duration-200`}
                />
              </motion.div>
              <h3 className="text-lg font-bold text-center mt-2">
                {reason.title}
              </h3>
              <p className="text-sm text-center mt-2">{reason.description}</p>
            </motion.div>
          </Tilt>
        ))}
      </div>
    </div>
  );
});


// HighlightShowcase Component
const HighlightShowcase = React.memo(({ theme }) => {
  const images = useMemo(
    () => [
      { src: highlight2, alt: 'Oversized Tee Collection' },
      { src: highlight3, alt: 'Custom Hoodie Prints' },
      { src: highlight5, alt: 'College Fest Merch' },
      { src: highlight4, alt: 'Graphic Tee Showcase' },
      { src: highlight1, alt: 'Tote Bag Designs' },
    ],
    []
  );

  const settings = useMemo(
    () => ({
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      arrows: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 640, settings: { slidesToShow: 1, arrows: false, dots: false } },
      ],
    }),
    []
  );

  return (
    <Parallax
      strength={200}
      className="py-12 sm:py-16 overflow-visible relative z-10"
      data-aos="fade-up"
    >
      <motion.h2
        className={`text-2xl sm:text-3xl lg:text-4xl font-poppins font-bold text-center ${
          theme === 'dark' ? 'text-white' : 'text-black'
        } mb-8 sm:mb-12`}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Highlight Showcase
      </motion.h2>

      <div className="w-full px-4 sm:px-6 lg:px-8 relative z-10">
        <Slider {...settings}>
          {images.map((image, index) => (
            <Tilt
              key={index}
              options={{ max: 15, scale: 1.05, speed: 400, perspective: 1000 }}
            >
              <motion.div
                className="px-2"
                data-aos="zoom-in"
                data-aos-delay={index * 100}
                whileHover={{ scale: 1.05, rotateX: 5, rotateY: 5 }}
                transition={{ duration: 0.3 }}
              >
                <div className="relative group overflow-hidden rounded-xl shadow-lg">
                  <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    className="w-full h-64 sm:h-72 lg:h-80 object-cover object-center transform transition duration-300 group-hover:brightness-110"
                  />
                  <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center px-2 text-center rounded-xl">
                    <p className="text-white text-xs sm:text-sm font-inter">{image.alt}</p>
                  </div>
                </div>
              </motion.div>
            </Tilt>
          ))}
        </Slider>
      </div>
    </Parallax>
  );
});


// CTABanner Component
const CTABanner = React.memo(() => {
  return (
    <div className="py-12 sm:py-16 bg-white text-center px-4 sm:px-6 lg:px-8" data-aos="fade-up">
      <motion.h2
        className="text-2xl sm:text-3xl lg:text-4xl font-poppins font-bold text-black mb-4 sm:mb-6"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Want College Merch for Your Fest?
      </motion.h2>

      <motion.p
        className="text-base sm:text-lg lg:text-xl font-inter text-black max-w-xl sm:max-w-2xl mx-auto mb-6 sm:mb-8"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
        Collaborate with us to create exclusive merchandise for your college events and festivals.
      </motion.p>

      <motion.div
        className="flex justify-center items-center gap-4 sm:gap-6 mb-6 sm:mb-8 flex-wrap"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        viewport={{ once: true }}
      >
        {[faTshirt, faGraduationCap, faStar].map((icon, index) => (
          <motion.div
            key={index}
            className="text-black text-2xl sm:text-3xl"
            whileHover={{ scale: 1.2, rotate: 15 }}
            transition={{ duration: 0.3 }}
          >
            <FontAwesomeIcon icon={icon} />
          </motion.div>
        ))}
      </motion.div>

      <motion.a
        href="https://www.instagram.com/flex_showitoff/?hl=en"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Send us a message on Instagram"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="inline-flex items-center justify-center bg-accent text-black px-5 sm:px-6 py-2.5 sm:py-3.5 rounded-full hover:bg-white border border-black transition duration-300 text-sm sm:text-base font-semibold font-inter shadow-md hover:shadow-lg"
      >
        <FontAwesomeIcon icon={faInstagram} className="mr-2" /> DM on Instagram
      </motion.a>
    </div>
  );
});

// Home Component
const Home = React.memo(({ theme }) => (
  <div>
    <Hero theme={theme} />
    <BestDesigns theme={theme} />
    <WhyChooseFlex />
    <HighlightShowcase theme={theme} />
    <CTABanner />
  </div>
));


// AboutIntro Component
const AboutIntro = React.memo(({ theme }) => (
  <section
    className={`py-16 px-4 sm:px-6 lg:px-8 ${
      theme === 'dark' ? 'bg-black' : 'bg-white'
    }`}
    data-aos="fade-up"
  >
    <motion.div
      className="max-w-4xl mx-auto text-center"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <motion.h1
        className={`text-3xl sm:text-4xl lg:text-5xl font-poppins font-bold leading-tight ${
          theme === 'dark' ? 'text-white' : 'text-black'
        }`}
        initial={{ scale: 0.9 }}
        whileInView={{ scale: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
        Who We Are
      </motion.h1>

      <motion.p
        className={`mt-4 text-base sm:text-lg lg:text-xl font-inter ${
          theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
        } max-w-3xl mx-auto`}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        viewport={{ once: true }}
      >
        Founded by college students, <strong>Flex Clothing</strong> is dedicated to creating trendy,
        affordable, and customizable apparel that resonates with the youth. We bring your college
        spirit to life with high-quality merchandise.
      </motion.p>
    </motion.div>
  </section>
));


// BrandTimeline Component
const BrandTimeline = React.memo(({ theme }) => {
  const timeline = useMemo(
    () => [
      {
        year: '2021',
        event: 'Concept Born',
        description:
          'In 2021, a group of passionate college students came together to brainstorm a bold idea: creating stylish, youth-centric merchandise that captures the essence of campus life. This marked the inception of Flex Clothing, driven by a vision to blend fashion with college pride.',
        icon: faLightbulb,
        color: 'text-yellow-400',
      },
      {
        year: '2022',
        event: 'First Prototype',
        description:
          'Our first oversized tee collection was launched in 2022, featuring unique designs crafted for comfort and style. These prototypes were tested at local college events, receiving enthusiastic feedback from students and setting the stage for our brand’s growth.',
        icon: faTshirt,
        color: 'text-indigo-500',
      },
      {
        year: '2023',
        event: 'Official Launch',
        description:
          'Flex Clothing officially hit the market in 2023 with a full range of apparel, including graphic tees, hoodies, and tote bags. Our launch was celebrated with a college fest collaboration, marking our entry as a go-to brand for trendy campus merchandise.',
        icon: faRocket,
        color: 'text-red-500',
      },
      {
        year: '2024',
        event: '100+ University Collaborations',
        description:
          "In just one year, Flex Clothing connected with over 50 universities, growing rapidly through word of mouth and social presence. Today, we've proudly crossed 100+ university collaborations across India, providing exclusive, customized merchandise at scale.",
        icon: faHandshake,
        color: 'text-teal-500',
      },
      {
        year: '2025',
        event: 'Nationwide Expansion',
        description:
          'In 2025, Flex Clothing expanded nationwide, reaching colleges across the country with our diverse range of products. From eco-friendly tote bags to vibrant fest merchandise, we’re now a trusted name for youth-focused apparel, driven by innovation and style.',
        icon: faGlobe,
        color: 'text-blue-600',
      },
    ],
    []
  );

  return (
    <div className="relative py-14 sm:py-20">
      <motion.h2
        className={`text-3xl sm:text-4xl font-poppins font-bold text-center mb-14 ${
          theme === 'dark' ? 'text-white' : 'text-black'
        }`}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Our Journey
      </motion.h2>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Vertical timeline line for larger screens */}
        <div className="hidden sm:block absolute top-0 left-1/2 transform -translate-x-1/2 h-full w-[2px] bg-gray-300 dark:bg-gray-600 z-0" />

        {timeline.map((item, index) => {
          const isLeft = index % 2 === 0;

          return (
            <div
              key={index}
              className={`relative mb-16 sm:mb-24 flex flex-col sm:flex-row items-center ${
                isLeft ? 'sm:justify-start' : 'sm:justify-end'
              }`}
            >
              {/* Content */}
              <motion.div
                className={`w-full sm:w-1/2 z-10 px-4 sm:px-0 ${
                  isLeft ? 'sm:pr-16 sm:text-right' : 'sm:pl-16 sm:text-left'
                }`}
                initial={{ opacity: 0, x: isLeft ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
              >
                <div
                  className={`p-5 rounded-xl shadow-lg border transition-all duration-300 ${
                    theme === 'dark'
                      ? 'bg-gray-800/90 text-white border-gray-700'
                      : 'bg-gray-100/90 text-black border-gray-200'
                  } font-inter`}
                >
                  <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2">
                    {item.year} — {item.event}
                  </h3>
                  <p className="text-sm sm:text-base leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </motion.div>

              {/* Center Icon */}
              <div className="absolute sm:left-1/2 sm:transform sm:-translate-x-1/2 sm:top-1 z-20 top-full sm:top-auto mt-4 sm:mt-0">
                <div className="bg-white dark:bg-black border-4 border-accent w-12 h-12 rounded-full flex items-center justify-center shadow-md">
                  <FontAwesomeIcon icon={item.icon} className={`${item.color} text-xl`} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});


// CoreValues Component
const CoreValues = React.memo(() => {
  const values = useMemo(
    () => [
      { name: 'Quality Focused', description: 'Premium materials for lasting wear.', icon: faGem, color: 'text-blue-700' },
      { name: 'Youth Vibes', description: 'Designs that capture the college spirit.', icon: faSmile, color: 'text-orange-600' },
      { name: 'Affordable', description: 'Trendy apparel that fits your budget.', icon: faDollarSign, color: 'text-green-600' },
      { name: 'Trendy Drops', description: 'Fresh collections to keep you in style.', icon: faFire, color: 'text-red-600' },
      { name: 'Customer First', description: 'Your satisfaction is our priority.', icon: faHeart, color: 'text-pink-600' },
    ],
    []
  );

  const settings = useMemo(
    () => ({
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      arrows: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 640, settings: { slidesToShow: 1, arrows: false, dots: false } },
      ],
    }),
    []
  );

  return (
    <div className="py-12 sm:py-16 bg-white" data-aos="fade-up">
      <motion.h2
        className="text-2xl sm:text-3xl lg:text-4xl font-poppins font-bold text-center text-black mb-8 sm:mb-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Our Core Values
      </motion.h2>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <Slider {...settings}>
          {values.map((value, index) => (
            <Tilt key={index} options={{ max: 20, scale: 1.05, speed: 400, perspective: 1000 }}>
              <motion.div
                className="px-2"
                data-aos="zoom-in"
                data-aos-delay={index * 100}
                whileHover={{ scale: 1.05, rotateX: 5, rotateY: 5, boxShadow: '0 15px 30px rgba(0,0,0,0.2)' }}
              >
                <div className="bg-white text-black p-6 rounded-xl shadow-md flex flex-col items-center justify-center min-h-[260px] font-inter">
                  <motion.div
                    data-aos="fade-up"
                    data-aos-delay={index * 150}
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    whileHover={{ scale: 1.2, rotate: 15 }}
                    transition={{ duration: 0.3 }}
                    className="text-3xl mb-3"
                  >
                    <FontAwesomeIcon icon={value.icon} className={`${value.color} hover:text-amber-500`} />
                  </motion.div>
                  <h3 className="text-lg font-bold text-center mt-2">{value.name}</h3>
                  <p className="text-sm text-center mt-2">{value.description}</p>
                </div>
              </motion.div>
            </Tilt>
          ))}
        </Slider>
      </div>
    </div>
  );
});

// About Component
const About = React.memo(({ theme }) => (
  <div>
    <AboutIntro theme={theme} />
    <BrandTimeline theme={theme} />
    <CoreValues />
  </div>
));

// Categories Component
const Categories = React.memo(({ theme }) => {
  const categories = useMemo(
    () => [
      {
        name: 'College Merchandise',
        description:
          'Showcase your college pride with our exclusive merchandise, crafted to embody the energy and spirit of campus life. Our collection includes vibrant graphic tees, custom hoodies, caps, and stickers, perfect for students, alumni, and fans. Whether you’re cheering at a game, attending a college fest, or just hanging out, our gear ensures you stand out with bold designs and premium quality.',
        images: [banner3, banner4, banner5],
      },
      {
        name: 'Oversized Tees',
        description:
          'Experience unmatched comfort and style with our oversized tees, designed for the modern youth. Made from soft, breathable cotton blends, these tees feature unique prints and relaxed fits, perfect for casual outings, study sessions, or layering with jackets. Available in a variety of trendy designs, they’re your go-to choice for effortless, everyday fashion.',
        images: [oversizedtees1, oversizedtees2],
      },
      {
        name: 'Hoodies',
        description:
          'Stay warm and fashionable with our premium hoodies, tailored for college students and young trendsetters. Crafted from cozy, durable materials, our hoodies come in a range of vibrant colors and bold graphic prints. Ideal for chilly campus evenings, gym sessions, or casual hangouts, they combine comfort and style for a versatile wardrobe staple.',
        images: [hoodies1, hoodies2, hoodies3],
      },
      {
        name: 'Tote Bags',
        description:
          'Carry your essentials with flair using our eco-friendly tote bags, designed for practicality and style. Made from sustainable, high-quality materials, these bags feature eye-catching designs and sturdy construction, perfect for carrying books, laptops, or festival gear. Make a statement while supporting the environment with our trendy, reusable totes.',
        images: [totebag1, totebag2, totebag3],
      },
      {
        name: 'Fest Orders',
        description:
          'Elevate your college festivals and events with our customizable bulk-order merchandise. From tees and hoodies to banners, lanyards, and wristbands, we offer tailored solutions to match your event’s theme and vibe. With fast production and delivery, our high-quality gear ensures your fest stands out, leaving a lasting impression on attendees.',
        images: [banner1, banner2],
      },
      {
        name: 'Graphic Tees',
        description:
          'Express your individuality with our graphic tees, featuring bold and creative designs that capture the latest trends. Crafted from premium cotton blends, these tees are perfect for making a statement, whether you’re into pop culture references, abstract art, or witty slogans. Ideal for college events or casual wear, they’re designed to turn heads.',
        images: [graphictees1, graphictees2, graphictees3],
      },
    ],
    []
  );

  const sliderSettings = useMemo(
    () => ({
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: false,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 640,
          settings: {
            dots: false,
          },
        },
      ],
    }),
    []
  );

  return (
    <Parallax strength={200} className={`py-12 sm:py-16 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`} data-aos="fade-up">
      <motion.h1
        className={`text-3xl sm:text-4xl lg:text-5xl font-poppins font-bold text-center ${theme === 'dark' ? 'text-white' : 'text-black'} mb-8 sm:mb-12`}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        We Deal In These Categories
      </motion.h1>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 space-y-12 sm:space-y-16">
        {categories.map((category, index) => (
          <Tilt key={index} options={{ max: 20, scale: 1.05, speed: 400, perspective: 1000 }}>
            <motion.div
              data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
              data-aos-delay={index * 100}
              className={`flex flex-col ${index % 2 === 0 ? 'sm:flex-row' : 'sm:flex-row-reverse'} items-center gap-6 sm:gap-8 bg-opacity-80 rounded-xl p-4 sm:p-6 shadow-lg ${theme === 'dark' ? 'bg-gray-800/90' : 'bg-gray-100/90'} font-inter`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="w-full sm:w-1/2">
                <Slider {...sliderSettings}>
                  {Array.isArray(category.images) ? (
                    category.images.map((image, imgIndex) => (
                      <Tilt key={imgIndex} options={{ max: 15, scale: 1.05, speed: 400, perspective: 1000 }}>
                        <motion.div
                          className="relative w-full aspect-[4/3]"
                          whileHover={{ scale: 1.05, rotateX: 5, rotateY: 5 }}
                          transition={{ duration: 0.3 }}
                        >
                          <img
                            src={image}
                            alt={`${category.name} Design ${imgIndex + 1}`}
                            className="w-full h-full object-cover rounded-lg shadow-md"
                            loading="lazy"
                            onError={(e) => {
                              e.target.src = 'https://via.placeholder.com/400?text=Image+Not+Found';
                            }}
                          />
                        </motion.div>
                      </Tilt>
                    ))
                  ) : (
                    <div className="text-center text-sm text-gray-500 font-inter">
                      No images available
                    </div>
                  )}
                </Slider>
              </div>
              <div className="w-full sm:w-1/2 text-center sm:text-left flex flex-col items-center sm:items-start justify-center">
                <motion.h3
                  className={`text-lg sm:text-xl lg:text-2xl font-poppins font-bold ${theme === 'dark' ? 'text-white' : 'text-black'} mt-4`}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {category.name}
                </motion.h3>
                <motion.p
                  className={`text-sm sm:text-base lg:text-lg font-inter ${theme === 'dark' ? 'text-white' : 'text-black'} mt-2 max-w-md`}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  viewport={{ once: true }}
                >
                  {category.description}
                </motion.p>
              </div>
            </motion.div>
          </Tilt>
        ))}
      </div>
    </Parallax>
  );
});

// Contact Component
const Contact = React.memo(({ theme }) => {
  return (
    <div className={`py-6 sm:py-16 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`} data-aos="fade-up">
      <motion.h1
        className={`text-3xl sm:text-4xl lg:text-5xl font-poppins font-bold text-center ${theme === 'dark' ? 'text-white' : 'text-black'} mb-4 sm:mb-12`}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Contact Us
      </motion.h1>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mt-8 sm:mt-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-6 mt-4">
            {[
              { href: 'https://wa.me/9268680066', icon: faWhatsapp, label: 'WhatsApp' },
              { href: 'mailto:flexshowitoff@gmail.com', icon: faEnvelope, label: 'Email' },
              { href: 'https://www.instagram.com/flex_showitoff/?hl=en', icon: faInstagram, label: 'Instagram' },
            ].map((link, index) => (
              <motion.a
                key={index}
                href={link.href}
                whileHover={{ scale: 1.1, color: '#f59e0b' }}
                className={`text-base sm:text-lg lg:text-xl font-inter ${theme === 'dark' ? 'text-white hover:text-accent' : 'text-black hover:text-accent'} transition flex items-center gap-2`}
              >
                <FontAwesomeIcon icon={link.icon} /> {link.label}
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
});

// Footer Component
const Footer = React.memo(({ theme }) => (
  <motion.footer
    className={`py-8 border-t ${theme === 'dark' ? 'bg-black border-gray-800' : 'bg-white border-gray-200'} font-inter`}
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
  >
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-4">
      <motion.p
        className={`${theme === 'dark' ? 'text-white' : 'text-black'} text-sm sm:text-base`}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
        © Flex Clothing 2025
      </motion.p>
      <div className="flex gap-4 sm:gap-6">
        {[
          {
            href: 'https://www.instagram.com/flex_showitoff/?hl=en',
            icon: faInstagram,
            label: 'Instagram',
          },
          {
            href: 'https://wa.me/9268680066',
            icon: faWhatsapp,
            label: 'WhatsApp',
          },
          {
            href: 'mailto:flexshowitoff@gmail.com',
            icon: faEnvelope,
            label: 'Email',
          },
        ].map((link, index) => (
          <motion.a
            key={index}
            href={link.href}
            aria-label={link.label}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.2, rotate: 15 }}
            className={`${theme === 'dark' ? 'text-white hover:text-accent' : 'text-black hover:text-accent'} transition duration-200 font-inter`}
          >
            <FontAwesomeIcon icon={link.icon} size="lg" />
          </motion.a>
        ))}
      </div>
    </div>
  </motion.footer>
));

// App Component
const App = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Dynamically load Google Fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&family=Inter:wght@400;500;600&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    // Apply global font styles
    const style = document.createElement('style');
    style.textContent = `
      :root {
        --accent: #f59e0b;
      }
      .font-poppins {
        font-family: 'Poppins', sans-serif;
      }
      .font-inter {
        font-family: 'Inter', sans-serif;
      }
      .scrollbar-hide::-webkit-scrollbar {
        display: none;
      }
      .scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
      .snap-x {
        scroll-snap-type: x mandatory;
      }
      .snap-center {
        scroll-snap-align: center;
      }
      .slick-slide > div {
        display: flex;
        justify-content: center;
      }
      .slick-dots li button:before {
        color: var(--accent);
        font-size: 10px;
      }
      .slick-dots li.slick-active button:before {
        color: var(--accent);
        opacity: 1;
      }
    `;
    document.head.appendChild(style);

    localStorage.setItem('theme', theme);
    AOS.init({ duration: 1000, once: true });

    // Simulate loading delay (replace with actual loading logic if needed)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(style);
      clearTimeout(timer);
    };
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  if (isLoading) {
  return (
    <div
      className={`min-h-screen flex flex-col justify-center items-center px-4 ${
        theme === 'dark' ? 'bg-black text-white' : 'bg-white text-black'
      }`}
    >
      {/* Responsive bouncing dots */}
      <motion.div
        className="flex gap-3 sm:gap-4"
        initial="hidden"
        animate="visible"
        variants={{
          visible: {
            transition: {
              staggerChildren: 0.2,
              repeat: Infinity,
              repeatType: "loop",
            },
          },
        }}
      >
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className="w-3 h-3 sm:w-4 sm:h-4 rounded-full"
            style={{
              backgroundColor: theme === 'dark' ? '#f59e0b' : '#000',
            }}
            variants={{
              hidden: { y: 0, opacity: 0.3 },
              visible: {
                y: [0, -12, 0],
                opacity: [0.3, 1, 0.3],
                transition: { duration: 0.6, repeat: Infinity },
              },
            }}
          />
        ))}
      </motion.div>

      {/* Brand text */}
      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="text-lg sm:text-xl md:text-2xl font-poppins font-semibold tracking-wide mt-6 text-center"
      >
        Flex Clothing – College Merchandise
      </motion.h2>
    </div>
  );
}


  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'bg-black text-white' : 'bg-white text-black'} font-inter`}>
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <section id="home">
        <Home theme={theme} />
      </section>
      <section id="about">
        <About theme={theme} />
      </section>
      <section id="categories">
        <Categories theme={theme} />
      </section>
      <section id="contact">
        <Contact theme={theme} />
      </section>
      <Footer theme={theme} />
    </div>
  );
};

export default App;